import type { CityData } from "./cities-data.types";

export const CITY_CATALOG_C: CityData[] = [
  // Gujarat
  {
    slug: "rajkot",
    name: "Rajkot",
    name_hi: "राजकोट",
    state: "Gujarat",
    latitude: 22.3039,
    longitude: 70.8022,
    timezone: "Asia/Kolkata",
    regional_note:
      "Rajkot's spiritual heart beats at the BAPS Swaminarayan Mandir on Kalawad Road, a magnificent complex established in 1998 that draws thousands of pilgrims year-round. The ancient Panchnath Mandir, dedicated to Lord Shiva, is one of the city's most revered shrines. Rajkot is famed across Gujarat for its exuberant Navratri Garba, which continues until dawn through nine nights, and its five-day Janmashtami Mela at the Race Course grounds draws over ten lakh visitors annually. All panchang, choghadiya, and rahu kaal timings are computed for Rajkot's exact coordinates in Indian Standard Time.",
    local_festivals: ["Navratri (Garba)", "Janmashtami Mela", "Uttarayan (Makar Sankranti)"],
  },
  {
    slug: "gandhinagar",
    name: "Gandhinagar",
    name_hi: "गांधीनगर",
    state: "Gujarat",
    latitude: 23.2156,
    longitude: 72.6369,
    timezone: "Asia/Kolkata",
    regional_note:
      "The capital of Gujarat is home to Swaminarayan Akshardham, one of India's most celebrated temple complexes, a 23-acre masterpiece built from 6,000 tonnes of pink Rajasthani sandstone, inaugurated in 1992, with over two hundred sacred murtis and no steel in its construction. Gandhinagar's Navratri celebrations draw devotees from across the state to traditional Garba gatherings, while Uttarayan fills the skies with kites each January. The 15th-century Adalaj Stepwell, 18 km away in Adalaj village, is a heritage landmark of Hindu-era craftsmanship. Panchang, choghadiya, and rahu kaal timings are computed for Gandhinagar's exact coordinates.",
    local_festivals: ["Navratri (Garba)", "Uttarayan (Makar Sankranti)", "Diwali"],
  },
  {
    slug: "jamnagar",
    name: "Jamnagar",
    name_hi: "जामनगर",
    state: "Gujarat",
    latitude: 22.4707,
    longitude: 70.0577,
    timezone: "Asia/Kolkata",
    regional_note:
      "The Bala Hanuman Temple on the banks of Ranmal Lake has held an unbroken recitation of 'Sri Ram, Jai Ram, Jai Jai Ram' every hour of every day since 1 August 1964, earning a Guinness World Record. Sidhnath Mahadev Temple and Bholeshwar Mahadev, which hosts its own annual fair on Shravani Amavas, are among Jamnagar's venerated Shiva shrines. The sacred pilgrim city of Dwarka lies approximately 141 km from Jamnagar, making the region a gateway to one of Hinduism's Char Dham. Navratri, Janmashtami, and Uttarayan are celebrated with characteristic Gujarati fervour. Panchang, choghadiya, and rahu kaal timings are computed for Jamnagar's exact coordinates.",
    local_festivals: [
      "Navratri (Garba)",
      "Janmashtami",
      "Shravani Amavas fair (Bholeshwar Mahadev)",
    ],
  },
  {
    slug: "bhavnagar",
    name: "Bhavnagar",
    name_hi: "भावनगर",
    state: "Gujarat",
    latitude: 21.7645,
    longitude: 72.1519,
    timezone: "Asia/Kolkata",
    regional_note:
      "Perched on a hillock at the city's centre, Takhteshwar Temple, a white marble Shiva shrine commissioned in 1893 by Maharaja Takhatsinhji, commands sweeping views of the Gulf of Khambhat and draws throngs of devotees each Maha Shivaratri. The contemporaneous Gangajalia temple, also of white marble, is dedicated to Ganga Devi. Around 25 km away at Koliyak Beach lies Nishkalank Mahadev, a cluster of five swayambhu Shivalingas on a tidal island in the Arabian Sea, accessible only at low tide and host to the celebrated Bhadarvi Amas fair. Navratri and Diwali are observed with great enthusiasm across Bhavnagar. Panchang, choghadiya, and rahu kaal timings are computed for Bhavnagar's exact coordinates.",
    local_festivals: [
      "Maha Shivaratri",
      "Navratri (Garba)",
      "Bhadarvi Amas fair (Nishkalank Mahadev)",
    ],
  },
  {
    slug: "junagadh",
    name: "Junagadh",
    name_hi: "जूनागढ़",
    state: "Gujarat",
    latitude: 21.5222,
    longitude: 70.4579,
    timezone: "Asia/Kolkata",
    regional_note:
      "At the foot of the sacred Girnar mountain stands Bhavnath Mahadev temple, where each Maha Shivaratri the Bhavnath Mela draws hundreds of thousands of pilgrims and Naga Sadhus for an overnight vigil believed to be blessed by Lord Shiva's own presence. The Girnar hill, accessed by roughly 10,000 steps, shelters the Ambika (Amba Mata) temple on its climb and the Dattatreya temple at its highest peak. Junagadh's Navratri, Janmashtami, and Diwali are observed with deep devotion. Mount Girnar makes Junagadh one of Gujarat's foremost pilgrimage destinations. Panchang, choghadiya, and rahu kaal timings are computed for Junagadh's exact coordinates.",
    local_festivals: ["Maha Shivaratri (Bhavnath Mela)", "Navratri (Garba)", "Janmashtami"],
  },
  {
    slug: "anand",
    name: "Anand",
    name_hi: "आनंद",
    state: "Gujarat",
    latitude: 22.5645,
    longitude: 72.9289,
    timezone: "Asia/Kolkata",
    regional_note:
      "Known nationwide as the Milk Capital of India and the birthplace of the Amul cooperative movement, Anand's devotional life centres on the BAPS Swaminarayan Mandir, a six-storey temple of striking architecture just 0.65 km from Anand Junction railway station. The Vadtal Swaminarayan Mandir, the 1824 southern-diocese headquarters of the original Swaminarayan Sampraday, lies 13 km away, while the famous Ranchhodraiji (Lord Krishna) temple at Dakor is approximately 40 km distant. Janmashtami, Annakut, Diwali, and Sharad Purnima are celebrated with particular joy here. Panchang, choghadiya, and rahu kaal timings are computed for Anand's exact coordinates.",
    local_festivals: ["Janmashtami", "Annakut", "Sharad Purnima"],
  },
  {
    slug: "somnath",
    name: "Somnath",
    name_hi: "सोमनाथ",
    state: "Gujarat",
    latitude: 20.9026,
    longitude: 70.3838,
    timezone: "Asia/Kolkata",
    sunrise_range: "6:15–7:30 AM",
    regional_note:
      "Somnath, the first and most sacred of the 12 Jyotirlingas, has been rebuilt 17 times after repeated destruction — a symbol of Hindu resilience. The seaside temple is lit by the setting sun at dusk. The Aarti timings at dawn and dusk are timed precisely to astronomical sunrise and sunset. Somnath is a mandatory pilgrimage for Shiva devotees. Mahashivaratri draws over 500,000 pilgrims to the town.",
    local_festivals: ["Mahashivaratri", "Kartik Purnima", "Navratri"],
  },
  {
    slug: "dwarka",
    name: "Dwarka",
    name_hi: "द्वारका",
    state: "Gujarat",
    latitude: 22.2393,
    longitude: 68.9678,
    timezone: "Asia/Kolkata",
    sunrise_range: "6:30–7:40 AM",
    regional_note:
      "Dwarka, one of India's four sacred Dhams and seven Sapta Puri, is Lord Krishna's mythological kingdom. The Dwarkadhish Temple (Krishna) is among India's wealthiest temples. Dwarka sits at India's westernmost point — sunrise here is latest in the country due to longitude. Janmashtami celebrations here are among the most elaborate outside Mathura. The town is the starting point for the Dwarka-Somnath-Nageshwar Jyotirlinga pilgrimage circuit.",
    local_festivals: ["Janmashtami", "Holi", "Navratri"],
  },
  // Karnataka
  {
    slug: "hubli",
    name: "Hubli-Dharwad",
    name_hi: "हुबली-धारवाड़",
    state: "Karnataka",
    latitude: 15.3647,
    longitude: 75.124,
    timezone: "Asia/Kolkata",
    regional_note:
      "Siddharoodha Math, where Advaita saint Sri Siddharudha Maharaj attained samadhi in 1929, stands at the spiritual heart of Hubli and draws pilgrims from across Karnataka. Its annual Mahashivaratri chariot festival, once graced by Lokmanya Tilak and Mahatma Gandhi, fills the city with kirtan through the night. The 900-year-old Chalukya-era Chandramouleshwara Temple on the banks of Unkal Lake, built of black granite with four cardinal entrances, shelters an ancient Shivalinga. Banashankari Temple, a 13th-century shrine to Goddess Parvati, is 8 km away in Amargol. Panchang, choghadiya, and rahu kaal timings are computed for Hubli-Dharwad's exact coordinates.",
    local_festivals: [
      "Mahashivaratri Chariot Festival (Siddharoodha Math)",
      "Ugadi",
      "Ganesh Chaturthi",
    ],
  },
  {
    slug: "belagavi",
    name: "Belagavi",
    name_hi: "बेलगावी",
    state: "Karnataka",
    latitude: 15.8497,
    longitude: 74.4977,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kapileshwar Swamy Temple, revered as Dakshin Kashi and believed installed by Sage Kapila Muni, greets pilgrims completing the twelve Jyotirlinga circuit and is unique for the rare sight of Lord Shiva and Lord Vishnu enshrined face-to-face under one roof. Mahashivaratri and the Shravan Somvar Mondays draw thousands. Inside the Killa Fort, the 1,000-year-old Military Durga Devi Temple reveres Goddess Durga through Chalukya, Hoysala and Vijayanagara stone-craft. Belagavi's position at the Karnataka-Maharashtra-Goa cultural crossroads colours every Navaratri procession and Ganesh Chaturthi celebration. Panchang, choghadiya, and rahu kaal timings are computed for Belagavi's exact coordinates.",
    local_festivals: [
      "Mahashivaratri (Kapileshwar Temple)",
      "Shravan Somvar",
      "Navaratri and Dasara Palakhi",
    ],
  },
  {
    slug: "kalaburagi",
    name: "Kalaburagi",
    name_hi: "कलबुर्गी",
    state: "Karnataka",
    latitude: 17.3297,
    longitude: 76.8343,
    timezone: "Asia/Kolkata",
    regional_note:
      "Sharana Basaveshwara Temple in the heart of Kalaburagi enshrines the samadhi of a revered Lingayat saint celebrated for Dasoha, the philosophy that giving is earning, and Kayaka, dignified labour. An annual Jatra draws pilgrims from across India, and farmers still donate a portion of each harvest for the temple's free langar. Shri Kshetra Ganagapur, a major Dattatreya pilgrimage site at the Bhima-Amaraja confluence, lies roughly 38 km from the city. Guru Poornima and Amavasya gatherings at Ganagapur draw thousands of devotees. Panchang, choghadiya, and rahu kaal timings are computed for Kalaburagi's exact coordinates.",
    local_festivals: [
      "Sharana Basaveshwara Jatra",
      "Guru Poornima (Ganagapur)",
      "Makara Sankranti",
    ],
  },
  {
    slug: "tumkur",
    name: "Tumkur",
    name_hi: "तुमकुरु",
    state: "Karnataka",
    latitude: 13.3379,
    longitude: 77.101,
    timezone: "Asia/Kolkata",
    regional_note:
      "Siddaganga Matha, a 15th-century Lingayata monastery on the outskirts of Tumkur about 7 km on the Bangalore highway, feeds thousands of pilgrims daily under its Maha Dasoha tradition, a living legacy of the Basava philosophy. The hillocks surrounding the matha harbour ancient Shivalinga caves. Sri Mahalakshmi Temple at Goravanahalli, 36 km from Tumkur, celebrates Lakshadeepotsava and Varamahalakshmi with spectacular lamp-lighting. Ugadi and Mahashivaratri are observed citywide with traditional puja and local jataras. Panchang, choghadiya, and rahu kaal timings are computed for Tumkur's exact coordinates.",
    local_festivals: ["Lakshadeepotsava (Goravanahalli)", "Varamahalakshmi", "Mahashivaratri"],
  },
  {
    slug: "davangere",
    name: "Davangere",
    name_hi: "दावणगेरे",
    state: "Karnataka",
    latitude: 14.4644,
    longitude: 75.9218,
    timezone: "Asia/Kolkata",
    regional_note:
      "Durgambika Temple, built in 1932 in the Old Town of Davangere around a sacred stone said to have arrived from Dugavatti village two centuries ago, is the city's foremost pilgrimage centre. Its Dravidian gopuram towers over Halepet, and Tuesday and Friday mornings draw the longest queues of devotees seeking the goddess's blessing for health and marriage. A grand Durgambika Devi Jatre, a 10-day festival held every two years in March or April, brings pilgrims from across North Karnataka. Ugadi, Navaratri and Ganesh Chaturthi are celebrated throughout the city. Panchang, choghadiya, and rahu kaal timings are computed for Davangere's exact coordinates.",
    local_festivals: ["Durgambika Devi Jatre", "Ugadi", "Ganesh Chaturthi"],
  },
  {
    slug: "ballari",
    name: "Ballari",
    name_hi: "बल्लारी",
    state: "Karnataka",
    latitude: 15.1394,
    longitude: 76.9214,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kanaka Durgamma Temple in KHB Colony, Ballari, enshrines the city's Gramadevata in an extraordinary form: the self-manifested goddess is worshipped from the rear, where ten eyes adorn the idol, one of India's rarest darshan traditions. An annual Rathotsava proceeds by the light of early-morning lamps. Lakshmi Narasimha Temple in the city centre presents exquisite Dravidian stone-craft honouring Lord Narasimha. Ballari stands as the nearest major city to Hampi, the UNESCO World Heritage Vijayanagara capital about 60 km north-west, whose Virupaksha Temple has been active since the 7th century. Navaratri and Ugadi are the city's grandest celebrations. Panchang, choghadiya, and rahu kaal timings are computed for Ballari's exact coordinates.",
    local_festivals: ["Kanaka Durgamma Rathotsava", "Navaratri and Dasara", "Ugadi"],
  },
  {
    slug: "udupi",
    name: "Udupi",
    name_hi: "उडुपी",
    state: "Karnataka",
    latitude: 13.3409,
    longitude: 74.7421,
    timezone: "Asia/Kolkata",
    regional_note:
      "Sri Krishna Matha, founded in the 13th century by philosopher-saint Madhvacharya as the living seat of Dvaita Vedanta, makes Udupi one of coastal Karnataka's most sacred cities. Eight Ashta Mathas administer the temple in rotation, and Paryaya, the biennial transfer of stewardship held every two years in January, draws hundreds of thousands of pilgrims. Darshan through the Kanakana Kindi window, a small grated opening said to have appeared when the poet-saint Kanakadasa's devotion moved Lord Krishna to turn westward, is central to every visit. Sri Krishna Janmashtami fills the city with night-long celebrations. Panchang, choghadiya, and rahu kaal timings are computed for Udupi's exact coordinates.",
    local_festivals: ["Paryaya", "Sri Krishna Janmashtami", "Madhva Navami"],
  },
  // Tamil Nadu
  {
    slug: "tiruchirappalli",
    name: "Tiruchirappalli",
    name_hi: "तिरुचिरापल्ली",
    state: "Tamil Nadu",
    latitude: 10.7905,
    longitude: 78.7047,
    timezone: "Asia/Kolkata",
    regional_note:
      "The 3.8-billion-year-old Rock Fort in the heart of Tiruchirappalli hosts the Ucchi Pillayar (Ganesha) shrine at its 273-foot summit and the Thayumanaswamy Shiva temple mid-hill, both within the city. Srirangam, a river island forming part of the Tiruchirappalli Municipal Corporation, holds the world's largest functioning Hindu temple, the Sri Ranganathaswamy, revered as the foremost of the 108 Divya Desams. The city observes Vaikunta Ekadasi, the Srirangam Chariot Festival, Panguni Uthiram, and Aadi Perukku on the Kaveri. Panchang, choghadiya, and rahu kaal timings are computed for Tiruchirappalli's exact coordinates.",
    local_festivals: ["Vaikunta Ekadasi", "Srirangam Chariot Festival", "Panguni Uthiram"],
  },
  {
    slug: "salem",
    name: "Salem",
    name_hi: "सेलम",
    state: "Tamil Nadu",
    latitude: 11.6643,
    longitude: 78.146,
    timezone: "Asia/Kolkata",
    regional_note:
      "Salem's spiritual life centres on two ancient temples within the city: the Arulmigu Sugavaneswarar Shiva temple near the old bus stand, a 500-year-old Vijayanagara-era shrine known as the Kili Valamudair Kovil for its renowned stone carvings, and the Kottai Mariamman temple on the Tirumanimuthar riverbank, regarded as the eldest among Salem's eight city Mariamman shrines. The city marks the Aadi festival at Kottai Mariamman with fire-walking, Aadi Pooram at Sugavaneswarar, Navarathri, and Masi Magam. Panchang, choghadiya, and rahu kaal timings are computed for Salem's exact coordinates, in the foothills of the Shevaroy Hills.",
    local_festivals: ["Aadi Festival at Kottai Mariamman", "Aadi Pooram", "Navarathri"],
  },
  {
    slug: "tirupur",
    name: "Tirupur",
    name_hi: "तिरुपुर",
    state: "Tamil Nadu",
    latitude: 11.1085,
    longitude: 77.3411,
    timezone: "Asia/Kolkata",
    regional_note:
      "Tirupur, India's knitwear export capital supplying over 90 percent of the country's cotton hosiery, anchors its religious life at the Tirupur Eswaran Shiva temple within the city, while the celebrated Arulmigu Avinashilingeswarar temple, a Chola-era Paadal Petra Sthalam linked to the Saiva saint Sundaramoorthy Nayanar, stands in the nearby town of Avinashi about 15 km away. Pilgrims from Tirupur join the Avinashi Temple Car Festival, Thaipusam, Karthigai Deepam, and Pongal. Panchang, choghadiya, and rahu kaal timings are computed for Tirupur's exact coordinates, in the Kongu Nadu region of western Tamil Nadu.",
    local_festivals: ["Avinashi Temple Car Festival", "Thaipusam", "Karthigai Deepam"],
  },
  {
    slug: "tirunelveli",
    name: "Tirunelveli",
    name_hi: "तिरुनेलवेली",
    state: "Tamil Nadu",
    latitude: 8.7139,
    longitude: 77.7567,
    timezone: "Asia/Kolkata",
    regional_note:
      "At the heart of Tirunelveli stands the twin-sanctum Nellaiappar-Kanthimathi Amman temple, a 14-acre complex on the banks of the Thamirabarani river dedicated to Lord Shiva (Nellaiyappar, the Protector of Paddy) and Goddess Parvathi (Kanthimathi), and one of the five Pancha Sabha dance halls of Nataraja alongside Chidambaram and Madurai. The city celebrates the 10-day Aani Brahmostavam Chariot Festival, Thaipusam on the Thamirabarani, Karthigai Vazhipadu, and Masi Magam. Panchang, choghadiya, and rahu kaal timings are computed for Tirunelveli's exact coordinates, close to the Thamirabarani river in southern Tamil Nadu.",
    local_festivals: ["Aani Brahmostavam Chariot Festival", "Thaipusam", "Karthigai Vazhipadu"],
  },
  {
    slug: "erode",
    name: "Erode",
    name_hi: "इरोड",
    state: "Tamil Nadu",
    latitude: 11.341,
    longitude: 77.7172,
    timezone: "Asia/Kolkata",
    regional_note:
      "Perched on Thindalmalai hillock about 8 km from the city centre, the Arulmigu Velayuthaswamy (Thindal Murugan) temple is among the 108 Murugan temples praised in the Tirupugazh of Arunagiriar and serves as the foremost pilgrimage site of the Erode region. The Sangameswarar Shiva temple at the Dakshina Triveni Sangamam, the confluence of the Kaveri, Bhavani, and the mystic Amutha rivers, lies 15 km away in Bhavani. Erode observes Panguni Uthiram, Thaipusam, Kandha Shasti, and Pongal. Panchang, choghadiya, and rahu kaal timings are computed for Erode's exact coordinates, on the banks of the Kaveri.",
    local_festivals: ["Panguni Uthiram at Thindal Murugan", "Thaipusam", "Kandha Shasti"],
  },
  {
    slug: "vellore",
    name: "Vellore",
    name_hi: "वेल्लोर",
    state: "Tamil Nadu",
    latitude: 12.9165,
    longitude: 79.1325,
    timezone: "Asia/Kolkata",
    regional_note:
      "Inside the 16th-century Vellore Fort stands the Arulmigu Jalakandeswarar Shiva temple, a masterpiece of Vijayanagara architecture built by Chinna Bommi Nayaka in 1550 CE, with intricate sculptures across its pillared mandapams. The Sri Lakshmi Narayani Golden Temple at Sripuram, with its gold-covered vimana, lies about 10 km from the city in the Thirumalaikodi suburb. Vellore observes Chitra Poornima as a ten-day festival, Aadi Pooram, Navarathri, and Surasamharam. Panchang, choghadiya, and rahu kaal timings are computed for Vellore's exact coordinates.",
    local_festivals: ["Chitra Poornima", "Aadi Pooram", "Navarathri"],
  },
  {
    slug: "thanjavur",
    name: "Thanjavur",
    name_hi: "तंजावुर",
    state: "Tamil Nadu",
    latitude: 10.7869,
    longitude: 79.1378,
    timezone: "Asia/Kolkata",
    regional_note:
      "Thanjavur's Brihadeeswarar temple, built by Chola emperor Rajaraja I between 1003 and 1010 CE and part of the UNESCO World Heritage Great Living Chola Temples, is one of the largest Shiva temples ever constructed, its 216-foot vimana dominating the city skyline. The ten-day Natyanjali classical dance festival, held each February around Maha Shivaratri, draws artists from across India to perform at the temple. The city also observes Aani Thirumanjanam, Arudra Darshanam, and Panguni Uthiram. Panchang, choghadiya, and rahu kaal timings are computed for Thanjavur's exact coordinates, on the Cauvery delta.",
    local_festivals: ["Natyanjali Dance Festival", "Maha Shivaratri", "Arudra Darshanam"],
  },
  {
    slug: "thoothukudi",
    name: "Thoothukudi",
    name_hi: "तूतीकोरिन",
    state: "Tamil Nadu",
    latitude: 8.7642,
    longitude: 78.1348,
    timezone: "Asia/Kolkata",
    regional_note:
      "Known as Pearl City for its historic pearl-fishing heritage in the Gulf of Mannar, Thoothukudi holds the Teppakulam Mariamman Kovil as one of its most important in-city shrines, and Aadi Fridays draw pilgrims from across the region. The renowned Arulmigu Subramaniya Swamy temple, second of Lord Murugan's six Arupadai Veedu shrines and the only one situated directly on the seashore, is located in Tiruchendur, 40 km from Thoothukudi. The city observes Aadi Velli, Karthigai Deepam, and Pongal. Panchang, choghadiya, and rahu kaal timings are computed for Thoothukudi's exact coordinates, on the Gulf of Mannar coast.",
    local_festivals: ["Aadi Velli (Aadi Fridays)", "Karthigai Deepam", "Pongal"],
  },
  {
    slug: "rameswaram",
    name: "Rameswaram",
    name_hi: "रामेश्वरम",
    state: "Tamil Nadu",
    latitude: 9.2885,
    longitude: 79.3129,
    timezone: "Asia/Kolkata",
    sunrise_range: "5:55–6:30 AM",
    regional_note:
      "Rameswaram, one of India's four sacred Dhams, is where Lord Rama worshipped Shiva before crossing to Lanka. The Ramanathaswamy Temple has the world's longest temple corridors (1,200+ meters). The sacred 22 theerthams (temple tanks) are used for ritual bathing in Panchanga-prescribed sequence. Pilgrims often combine Rameswaram with Kanyakumari (India's southernmost tip) in the same yatra. Every pilgrimage here follows the Panchanga.",
    local_festivals: ["Ram Navami", "Mahashivaratri", "Thiruvathira"],
  },
  {
    slug: "kancheepuram",
    name: "Kancheepuram",
    name_hi: "कांचीपुरम",
    state: "Tamil Nadu",
    latitude: 12.8185,
    longitude: 79.6947,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kancheepuram, the City of a Thousand Temples, contains three of South India's most sacred shrines within its limits: Kamakshi Amman temple, one of the foremost Shakti Peethas; Ekambareswarar temple, one of the Pancha Bhuta Sthalams representing the earth element, with a 192-foot southern gopuram among the tallest in India; and the 23-acre Varadaraja Perumal temple with its 400-pillared halls. The city's most celebrated event is the 13-day Panguni Uthiram Brahmotsavam at Ekambareswarar and the Garuda Seva at Varadaraja. Panchang, choghadiya, and rahu kaal timings are computed for Kancheepuram's exact coordinates, in the Tondaimandalam region.",
    local_festivals: [
      "Panguni Uthiram Brahmotsavam",
      "Garuda Seva at Varadaraja Perumal",
      "Navarathri",
    ],
  },
  {
    slug: "kumbakonam",
    name: "Kumbakonam",
    name_hi: "कुम्बकोणम",
    state: "Tamil Nadu",
    latitude: 10.9617,
    longitude: 79.3788,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kumbakonam takes its very name from legend: a primordial pot (kumbha) said to contain the seeds of all life came to rest here by Shiva's arrow, giving rise to both the city and the Adi Kumbeswarar Shiva temple, a 9th-century Chola-era shrine at the city's heart and the focal point of the once-in-12-years Mahamaham festival when lakhs bathe in the sacred Mahamaham tank. The Sarangapani temple, tallest Vishnu shrine in Kumbakonam and a Divya Desam, stands in the same precinct. The city also celebrates Maha Shivaratri, Thaipusam, and Arudra Darshanam. Panchang, choghadiya, and rahu kaal timings are computed for Kumbakonam's exact coordinates, on the Cauvery-Arasalar delta.",
    local_festivals: ["Mahamaham Festival", "Maha Shivaratri", "Thaipusam"],
  },
  {
    slug: "palani",
    name: "Palani",
    name_hi: "पलनी",
    state: "Tamil Nadu",
    latitude: 10.4487,
    longitude: 77.5246,
    timezone: "Asia/Kolkata",
    regional_note:
      "Palani is defined by the Arulmigu Dhandayuthapani Swamy temple, one of the six Arupadai Veedu, Lord Murugan's principal abodes, seated atop a rocky hillock within the town and worshipped in the rare form of Murugan holding only a staff, having renounced all ornaments. Thaipusam here is the defining annual event: pilgrims arrive from across Tamil Nadu, Kerala, and beyond bearing kavadi over a 10-day celebration. Panguni Uthiram, Vaikashi Visakam, and Kandha Shasti are also major observances. Panchang, choghadiya, and rahu kaal timings are computed for Palani's exact coordinates, in the Dindigul district foothills.",
    local_festivals: ["Thaipusam (Kavadi festival)", "Panguni Uthiram", "Vaikashi Visakam"],
  },
  {
    slug: "tiruvannamalai",
    name: "Tiruvannamalai",
    name_hi: "तिरुवण्णामलै",
    state: "Tamil Nadu",
    latitude: 12.2253,
    longitude: 79.0747,
    timezone: "Asia/Kolkata",
    regional_note:
      "Tiruvannamalai is among India's most sacred pilgrimage sites: the Arulmigu Arunachaleswarar temple at the foot of Arunachala Hill enshrines the Agni Lingam representing fire, the city's place in the Pancha Bhuta Sthalams. Each full-moon night draws over a million devotees on Girivalam, the 14-kilometre barefoot circumambulation of Arunachala Hill. The 10-day Karthigai Deepam culminates in the Maha Deepam flame, lit with 3,500 kg of ghee on the hilltop and visible 35 km away, drawing millions of pilgrims annually. Maha Shivaratri and Panguni Brahmotsavam are also major festivals. Panchang, choghadiya, and rahu kaal timings are computed for Tiruvannamalai's exact coordinates.",
    local_festivals: [
      "Karthigai Deepam / Maha Deepam",
      "Girivalam (monthly full moon)",
      "Maha Shivaratri",
    ],
  },
  // Kerala
  {
    slug: "kozhikode",
    name: "Kozhikode",
    name_hi: "कोझिकोड",
    state: "Kerala",
    latitude: 11.2588,
    longitude: 75.7804,
    timezone: "Asia/Kolkata",
    regional_note:
      "The Tali Shiva Temple in Kozhikode's Palayam neighbourhood, built in the 14th century by the Zamorins of Calicut as their royal family temple, houses a Jyothirlingam in a distinctive two-storied chariot-shaped sanctum adorned with mural paintings. Devotees observe Maha Shivaratri and the seven-day Malayalam New Year festival here with great devotion. The Azhakodi Devi Temple at Thiruthiyad, dedicated to Bhadrakali in seven maternal forms, draws pilgrims for Navarathri and its annual Medam flag-hoisting utsavam. Onam and Vishu are celebrated city-wide. Panchang, choghadiya, and rahu kaal timings are computed for Kozhikode's exact coordinates.",
    local_festivals: ["Maha Shivaratri", "Revathi Pattathanam", "Navarathri Mahotsavam"],
  },
  {
    slug: "thrissur",
    name: "Thrissur",
    name_hi: "त्रिशूर",
    state: "Kerala",
    latitude: 10.5276,
    longitude: 76.2144,
    timezone: "Asia/Kolkata",
    regional_note:
      "Thrissur is home to the Vadakkumnathan Temple, one of Kerala's oldest Shivalaya shrines, believed consecrated by Parashurama, standing on a hillock encircled by the vast Thekkinkadu Maidan. Every April-May it hosts Thrissur Pooram, the mother of all poorams: ten temples including Paramekkavu Bagavathi and Thiruvambady Sri Krishna converge in a 36-hour spectacle of caparisoned elephants, Chenda Melam, and fireworks drawing over a million visitors. Maha Shivaratri, Onam, and Vishu are observed with equal fervour across the city. Panchang, choghadiya, and rahu kaal timings are computed for Thrissur's exact coordinates.",
    local_festivals: ["Thrissur Pooram", "Maha Shivaratri", "Onam"],
  },
  {
    slug: "kollam",
    name: "Kollam",
    name_hi: "कोल्लम",
    state: "Kerala",
    latitude: 8.8932,
    longitude: 76.6141,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kollam's Asramam Sree Krishna Swamy Temple, perched atop a consecrated mound overlooking Ashtamudi Lake, anchors the annual Kollam Pooram, a ten-day April festival culminating in processions and fireworks at Asramam Maidan that draws devotees from across Kerala. The Anandavalleeshwaram Sri Mahadevar Temple in the city's west, an ancient Shiva shrine, celebrates its own ten-day Meenam festival featuring Pallivetta, Arattu, and Ezhunallathu rituals. Shivaratri, Onam, and Vishu draw large gatherings city-wide. Panchang, choghadiya, and rahu kaal timings are computed for Kollam's exact coordinates.",
    local_festivals: ["Kollam Pooram", "Maha Shivaratri", "Anandavalleeshwaram Meenam Festival"],
  },
  {
    slug: "kottayam",
    name: "Kottayam",
    name_hi: "कोट्टयम",
    state: "Kerala",
    latitude: 9.5916,
    longitude: 76.5222,
    timezone: "Asia/Kolkata",
    regional_note:
      "At the cultural heart of Kottayam city stands the Thirunakkara Sree Mahadevar Temple, one of Kerala's 108 Shivalaya shrines, its four-acre campus housing one of the state's largest Koothambalams for traditional temple theatre. Its ten-day annual festival, marked by a procession of nine caparisoned elephants and performances of Mayilattom and Velakali, draws pilgrims region-wide. Twelve kilometres away, the renowned Ettumanoor Mahadevar Temple celebrates Thiruvathira Arattu with the legendary Ezhara Ponnana, seven-and-a-half golden elephant statuettes displayed at midnight. Onam and Vishu are observed across the city. Panchang, choghadiya, and rahu kaal timings are computed for Kottayam's exact coordinates.",
    local_festivals: [
      "Thirunakkara Mahadeva Festival",
      "Ezhara Ponnana at Ettumanoor",
      "Thiruvathira",
    ],
  },
  {
    slug: "palakkad",
    name: "Palakkad",
    name_hi: "पलक्काड",
    state: "Kerala",
    latitude: 10.7867,
    longitude: 76.6548,
    timezone: "Asia/Kolkata",
    regional_note:
      "Palakkad's most celebrated sacred event is the Kalpathi Ratholsavam, held every November at the Sree Viswanatha Swamy Temple in Kalpathi, a 400-year-old Tamil Brahmin agraharam just 3 km from Palakkad town. Three enormous decorated wooden chariots are pulled through heritage streets to the rhythms of Panchavadyam and Carnatic music. The Sree Emoor Bhagavathy Temple at Kallekulangara near Palakkad, housing a swayambhu form of Goddess Parvati, draws lakhs for the Meena Bharani Mahotsavam in March-April. Onam and Vishu are celebrated across the city. Panchang, choghadiya, and rahu kaal timings are computed for Palakkad's exact coordinates, near the Palakkad Gap.",
    local_festivals: ["Kalpathi Ratholsavam", "Meena Bharani Mahotsavam", "Onam"],
  },
  {
    slug: "kannur",
    name: "Kannur",
    name_hi: "कन्नूर",
    state: "Kerala",
    latitude: 11.8745,
    longitude: 75.3704,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kannur is the living heartland of Theyyam, Kerala's ancient ritual art in which performer-priests embody deities through elaborate costumes, face paint, and trance dance, performed at kavus and tharavads across the district from November to May. The Parassinikadavu Sri Muthappan Temple, 20 km from Kannur town on the Valapattanam river, is unique in Kerala for its daily Theyyam ritual open to devotees of all faiths, with fish, toddy, and tea among the sacred prasadam. Puthari Thiruvappana in December marks the temple year's beginning. Onam and Vishu are celebrated city-wide. Panchang, choghadiya, and rahu kaal timings are computed for Kannur's exact coordinates.",
    local_festivals: ["Theyyam Season", "Puthari Thiruvappana", "Onam"],
  },
  {
    slug: "alappuzha",
    name: "Alappuzha",
    name_hi: "अलप्पुझा",
    state: "Kerala",
    latitude: 9.4981,
    longitude: 76.3388,
    timezone: "Asia/Kolkata",
    regional_note:
      "The Mullakkal Rajarajeswari Temple, nearly 500 years old and set amid a jasmine garden in the heart of Alappuzha city, enshrines Goddess Durga as Rajarajeswari beneath an open-roof sanctum unique to Kerala temple architecture. Its 41-day Mullakkal Chirappu festival from November to January draws thousands to parades of caparisoned elephants, with Navaratri marked by the worship of Kumari girls. Alappuzha's Punnamada Lake hosts the Nehru Trophy Boat Race every second Saturday of August, majestic snake boats rowed by over a hundred oarsmen in a tradition begun in 1952. Onam and Vishu are celebrated city-wide. Panchang, choghadiya, and rahu kaal timings are computed for Alappuzha's exact coordinates, in Kerala's backwater heartland.",
    local_festivals: ["Mullakkal Chirappu", "Navaratri", "Nehru Trophy Boat Race"],
  },
  {
    slug: "guruvayur",
    name: "Guruvayur",
    name_hi: "गुरुवायुर",
    state: "Kerala",
    latitude: 10.5938,
    longitude: 76.0361,
    timezone: "Asia/Kolkata",
    sunrise_range: "6:10–6:40 AM",
    regional_note:
      "Guruvayur, home to the Guruvayurappan (Krishna) Temple, is often called the 'Dwarka of South India' and is Kerala's most visited pilgrim site with 15,000+ daily visitors. The temple's strict Brahminic traditions include precise timing for 8 daily poojas based on the Panchangam. Guruvayur Ekadasi (Vrikachalam Ekadasi) is the temple's most sacred festival. The temple's sacred elephant procession (Elephant Pageant) follows lunar calendar dates.",
    local_festivals: ["Guruvayur Ekadasi", "Vishu", "Utsavam"],
  },
  // Andhra Pradesh
  {
    slug: "nellore",
    name: "Nellore",
    name_hi: "नेल्लोर",
    state: "Andhra Pradesh",
    latitude: 14.4426,
    longitude: 79.9865,
    timezone: "Asia/Kolkata",
    regional_note:
      "Sri Talpagiri Ranganatha Swamy Temple, rising on the banks of the Pennar river with a 29-metre Galigopuram adorned by seven golden kalasams, anchors Nellore's spiritual life and is more than 600 years old. The annual Brahmotsavam, culminating in Rathotsavam and Teppotsavam, draws lakhs of devotees. Penchalakona, home to one of the Nava Narasimha Kshethras, lies roughly 70 km away. Panchang, choghadiya, and rahu kaal timings are computed for Nellore's exact coordinates.",
    local_festivals: ["Brahmotsavam (Talpagiri Ranganatha)", "Rathotsavam", "Teppotsavam"],
  },
  {
    slug: "guntur",
    name: "Guntur",
    name_hi: "गुंटूर",
    state: "Andhra Pradesh",
    latitude: 16.3067,
    longitude: 80.4365,
    timezone: "Asia/Kolkata",
    regional_note:
      "Guntur district holds two of Andhra Pradesh's most celebrated shrines within day-trip distance. Amaravati Amareswara Swamy Temple, one of the five Pancharama Kshetras on the Krishna river, stands roughly 32 km from Guntur city. Mangalagiri's Panakala Lakshmi Narasimha Swamy Temple, famed for its unique jaggery-water offering accepted with an audible gurgling sound, lies about 21 km away. Maha Sivaratri, Brahmotsavam, and Narasimha Jayanti are the headline festivals. Panchang, choghadiya, and rahu kaal timings are computed for Guntur's exact coordinates.",
    local_festivals: [
      "Maha Sivaratri (Amararama)",
      "Brahmotsavam (Mangalagiri)",
      "Narasimha Jayanti",
    ],
  },
  {
    slug: "kurnool",
    name: "Kurnool",
    name_hi: "कुर्नूल",
    state: "Andhra Pradesh",
    latitude: 15.8281,
    longitude: 78.0373,
    timezone: "Asia/Kolkata",
    regional_note:
      "Sri Surya Narayana Swamy Temple stands within Kurnool city, while the district anchors a major pilgrimage circuit: Mahanandi's Nava Nandi shrines lie roughly 93 km away, and Srisailam Mallikarjuna Jyotirlinga, one of India's 12 Jyotirlingas, is about 180 km distant. Mantralayam, the sacred Jeevasamadhi of Sri Raghavendra Swamy on the Tungabhadra, is roughly 90 km away. Maha Sivaratri, Karthika Masa deepotsavam, and Nava Nandi pilgrimages draw Rayalaseema devotees year-round. Panchang, choghadiya, and rahu kaal timings are computed for Kurnool's exact coordinates.",
    local_festivals: ["Maha Sivaratri", "Karthika Masa Deepotsavam", "Nava Nandi Pilgrimage"],
  },
  {
    slug: "rajahmundry",
    name: "Rajahmundry",
    name_hi: "राजमुंद्री",
    state: "Andhra Pradesh",
    latitude: 17.0005,
    longitude: 81.7799,
    timezone: "Asia/Kolkata",
    regional_note:
      "Rajahmundry, the cultural capital of Andhra Pradesh, sits on the sacred Godavari and hosts the Maha Pushkaram, a mass river-pilgrimage held once every 12 years drawing millions of Hindus. Kotilingeswara Temple in the city, dedicated to Lord Shiva and believed to enshrine a crore of Shiva lingas, is revered as a Shakti Peetha. The ancient Markandeya Temple on the Godavari bank, patronised by Chalukya and Reddy kings, draws large crowds every Maha Sivaratri. Panchang, choghadiya, and rahu kaal timings are computed for Rajahmundry's exact coordinates.",
    local_festivals: [
      "Godavari Maha Pushkaram (12-yearly)",
      "Maha Sivaratri",
      "Karthika Purnima Godavari snan",
    ],
  },
  {
    slug: "kakinada",
    name: "Kakinada",
    name_hi: "काकीनाडा",
    state: "Andhra Pradesh",
    latitude: 16.9891,
    longitude: 82.2475,
    timezone: "Asia/Kolkata",
    regional_note:
      "Closest to Kakinada city is Sri Bhavannarayana Swamy Temple at Sarpavaram, 5 km away, an ASI-protected Chalukya-Chola structure counted among the 108 Divya Desams. Kumararama Sri Bhimeswara Swamy Temple, a Pancharama Kshetra, lies 12 km away at Samalkota, and Draksharama Bhimeswara, another Pancharama, is 28 km distant. Sri Kukkuteswara Swamy Temple, one of the 18 Shakti Peethas, stands at Pithapuram 20 km from the city. Karthika Masam and Maha Sivaratri are the primary festival seasons. Panchang, choghadiya, and rahu kaal timings are computed for Kakinada's exact coordinates.",
    local_festivals: [
      "Maha Sivaratri (Pancharama circuit)",
      "Sri Rama Navami",
      "Karthika Masam deepotsavam",
    ],
  },
  {
    slug: "kadapa",
    name: "Kadapa",
    name_hi: "कडपा",
    state: "Andhra Pradesh",
    latitude: 14.4674,
    longitude: 78.8241,
    timezone: "Asia/Kolkata",
    regional_note:
      "Devuni Kadapa holds Sri Lakshmi Venkateswara Swamy Temple in Vijayanagara style, the threshold of the divine where pilgrims traditionally seek blessings before ascending to Tirumala Tirupati. The nine-day Brahmotsavam each January, culminating in Rathotsavam and Kalyanotsavam, draws thousands. Gandi Kshetram, a Vayu Kshetra where Rama is said to have carved Anjaneya on rock, lies 55 km from the city. Panchang, choghadiya, and rahu kaal timings are computed for Kadapa's exact coordinates.",
    local_festivals: ["Brahmotsavam (Devuni Kadapa)", "Kalyanotsavam", "Rathotsavam"],
  },
  // Telangana
  {
    slug: "warangal",
    name: "Warangal",
    name_hi: "वारंगल",
    state: "Telangana",
    latitude: 17.9689,
    longitude: 79.5941,
    timezone: "Asia/Kolkata",
    regional_note:
      "Bhadrakali Temple, built circa 625 CE and later adopted as the Kakatiya dynasty's kuladevi or clan goddess, crowns a hilltop overlooking Bhadrakali Lake within Warangal city. The Thousand Pillar Temple, a 12th-century Kakatiya star-plan monument, stands in adjoining Hanamkonda 6 km away. Ramappa Temple, a 13th-century Kakatiya masterpiece and UNESCO World Heritage Site, lies roughly 70 km distant. Bonalu, Navaratri, and Bathukamma define the festival calendar. Panchang, choghadiya, and rahu kaal timings are computed for Warangal's exact coordinates.",
    local_festivals: ["Bonalu (Bhadrakali)", "Navaratri / Dasara", "Bathukamma"],
  },
  {
    slug: "nizamabad",
    name: "Nizamabad",
    name_hi: "निज़ामाबाद",
    state: "Telangana",
    latitude: 18.6725,
    longitude: 78.0942,
    timezone: "Asia/Kolkata",
    regional_note:
      "Neelakanteshwara, or Kanteshwar, Temple, an ancient Shiva shrine at the heart of Nizamabad city, draws pilgrims from Telangana, Maharashtra, and Karnataka, and Puranas hold that Brahma himself worshipped the Shivalinga here, giving it exceptional sanctity. Maha Sivaratri at Kanteshwar is celebrated with state-wide fervour. A Raghunatha Temple within the historic Nizamabad Fort completes the city's sacred landscape. Bonalu, Bathukamma, Rathasaptami, and Ugadi mark the annual cycle. Panchang, choghadiya, and rahu kaal timings are computed for Nizamabad's exact coordinates.",
    local_festivals: ["Maha Sivaratri", "Rathasaptami", "Bathukamma"],
  },
  {
    slug: "karimnagar",
    name: "Karimnagar",
    name_hi: "करीमनगर",
    state: "Telangana",
    latitude: 18.4386,
    longitude: 79.1288,
    timezone: "Asia/Kolkata",
    regional_note:
      "Karimnagar's dominant pilgrimage is Vemulawada Raja Rajeshwara Temple, 38 km from the city, where Shiva is venerated as Rajanna by devotees across Telangana, and Maha Sivaratri here is one of the state's largest gatherings. Kondagattu Anjaneya Swamy Temple, a celebrated Hanuman shrine on a hillock, lies about 35 km away. Nagunur Fort and Kakatiya-era Elgandal Fort, roughly 10 km from the city on the Manair river, hold ancient temple ruins. Bonalu and Bathukamma complete the local calendar. Panchang, choghadiya, and rahu kaal timings are computed for Karimnagar's exact coordinates.",
    local_festivals: ["Maha Sivaratri (Vemulawada Rajanna)", "Bonalu", "Bathukamma"],
  },
  // Punjab
  {
    slug: "jalandhar",
    name: "Jalandhar",
    name_hi: "जालंधर",
    state: "Punjab",
    latitude: 31.326,
    longitude: 75.5762,
    timezone: "Asia/Kolkata",
    regional_note:
      "Devi Talab Mandir, one of the 51 Shakti Peethas of India, anchors Jalandhar's Hindu identity with its sacred 200-year-old tank and an Amarnath-replica Shiva shrine within the complex. Sodal Mandir, dedicated to the child deity Baba Sodal, and the ancient Sheetla Mata Mandir near Balmiki Gate are further in-city shrines. The temple hosts the Hari Vallabh Sangeet Sammelan, established 1875, India's oldest classical-music gathering, held each December. Navratri draws lakhs of pilgrims to Devi Talab. Panchang, choghadiya, and rahu kaal timings are computed for Jalandhar's exact coordinates.",
    local_festivals: ["Navratri (Devi Talab Mandir)", "Hari Vallabh Sangeet Sammelan", "Diwali"],
  },
  {
    slug: "patiala",
    name: "Patiala",
    name_hi: "पटियाला",
    state: "Punjab",
    latitude: 30.3398,
    longitude: 76.3869,
    timezone: "Asia/Kolkata",
    regional_note:
      "Built in 1936 by Maharaja Bhupinder Singh of Patiala, the Kali Mata Mandir on Mall Road houses a six-foot idol of Goddess Kali brought from Bengal and draws up to 1.5 lakh devotees during Navratri. The Raj Rajeshwari temple within the same complex adds further antiquity. Navratri is the city's foremost Hindu festival, and Diwali and Ram Navami are celebrated widely across Patiala's mixed Hindu-Sikh community. The nearby Dukh Niwaran Sahib is a Sikh Gurudwara. Panchang, choghadiya, and rahu kaal timings are computed for Patiala's exact coordinates.",
    local_festivals: ["Navratri (Kali Mata Mandir)", "Diwali", "Ram Navami"],
  },
  {
    slug: "bathinda",
    name: "Bathinda",
    name_hi: "बठिंडा",
    state: "Punjab",
    latitude: 30.211,
    longitude: 74.9455,
    timezone: "Asia/Kolkata",
    regional_note:
      "Bathinda is a predominantly Hindu city in the Malwa region of Punjab, with in-city shrines including Durga Mandir and Radha Krishna Temple. The Maiser Khana temple dedicated to Goddesses Jwala Ji and Durga is located 29 km from the city on the Bathinda-Mansa Road and hosts two large melas annually as a district attraction. Lohri bonfires in January and Navratri celebrations mark the Hindu festival calendar, alongside Diwali. Panchang, choghadiya, and rahu kaal timings are computed for Bathinda's exact coordinates.",
    local_festivals: ["Navratri", "Lohri", "Maiser Khana Melas"],
  },
  {
    slug: "mohali",
    name: "Mohali",
    name_hi: "मोहाली",
    state: "Punjab",
    latitude: 30.7046,
    longitude: 76.7179,
    timezone: "Asia/Kolkata",
    regional_note:
      "Mohali, also called SAS Nagar, is a planned satellite city of Chandigarh established in the 1960s, with in-city Hindu temples including Shri Shiv Mandir in Sohana village, Kashi Vishwanath Devasthanam in Sector 68, and Shri Laxmi Narayan Mandir among the oldest in the locality. The city's proximity to Chandigarh means the famous Mansa Devi temple is across the border in Panchkula, not in Mohali itself. Navratri, Diwali, and Janmashtami are observed at local mandirs. Panchang, choghadiya, and rahu kaal timings are computed for Mohali's exact coordinates.",
    local_festivals: ["Navratri", "Diwali", "Janmashtami"],
  },
  {
    slug: "pathankot",
    name: "Pathankot",
    name_hi: "पठानकोट",
    state: "Punjab",
    latitude: 32.2643,
    longitude: 75.6421,
    timezone: "Asia/Kolkata",
    regional_note:
      "Pathankot, gateway to Himachal Pradesh and the Dalhousie hills, holds several in-city shrines along Dalhousie Road: Ashapurni Temple, where Navratri Kanya Puja draws the largest local crowds, Pracheen Kali Mata Mandir, and Renuka Temple. The Kathgarh Mahadev with its split Shivalinga and Mukteshwar Mahadev are located outside city limits, Mukteshwar 22 km away at Shahpurkandi. Vaishno Devi's base camp Katra is approximately 49 km away in Jammu. Navratri is the foremost observed festival in Pathankot. Panchang, choghadiya, and rahu kaal timings are computed for Pathankot's exact coordinates.",
    local_festivals: ["Navratri (Ashapurni Temple)", "Diwali", "Maha Shivratri"],
  },
  // Haryana
  {
    slug: "gurugram",
    name: "Gurugram",
    name_hi: "गुरुग्राम",
    state: "Haryana",
    latitude: 28.4595,
    longitude: 77.0266,
    timezone: "Asia/Kolkata",
    regional_note:
      "Sheetla Mata Mandir, one of Haryana's most revered shrines on Sheetla Mata Road in old Gurugram, is the city's defining religious landmark, built in the eighteenth century by king Jawahar Singh. The goddess is worshipped as a healer, and her Sheetla Ashtami festival on the eighth day after Holi draws vast pilgrim gatherings when devotees offer basi khana, food prepared the previous night. Navratri sees the temple lit in elaborate devotion twice yearly, in Chaitra and Ashadh. Panchang, choghadiya, and rahu kaal timings are computed for Gurugram's exact coordinates.",
    local_festivals: ["Sheetla Ashtami", "Navratri (Chaitra and Sharad)", "Diwali"],
  },
  {
    slug: "rohtak",
    name: "Rohtak",
    name_hi: "रोहतक",
    state: "Haryana",
    latitude: 28.8955,
    longitude: 76.6066,
    timezone: "Asia/Kolkata",
    regional_note:
      "Durga Bhawan Mandir on National Highway 10 anchors Rohtak's Navratri celebrations with nine days of elaborate worship, drawing devotees from across the district. The Shiv Mandir in the city centre is the focal point of Mahashivratri, when the streets fill with processions and stalls. Asthal Bohar Math, a revered Nath-Shaiva institution 7 km east of the city, was revived in 1791 by Baba Mast Nath and remains an active centre for followers of the Gorakh Nath tradition. Panchang, choghadiya, and rahu kaal timings are computed for Rohtak's exact coordinates.",
    local_festivals: ["Navratri (Durga Bhawan Mandir)", "Mahashivratri", "Hanuman Jayanti"],
  },
  {
    slug: "hisar",
    name: "Hisar",
    name_hi: "हिसार",
    state: "Haryana",
    latitude: 29.1492,
    longitude: 75.7217,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kajla Dham, a celebrated Hanuman temple 16 km west of Hisar city, draws pilgrims for a sixteen-day festival in April featuring Akhand Ramcharitmanas recitation and group bhajans. Agroha Dham, 21 km from the city in the ancient town of Agroha, is a major Mahalakshmi temple whose Shakti Sarovar was consecrated with water from forty-one Indian rivers, and its Agroha Maha Kumbh is held on Sharad Purnima. Hisar's Kali Mata Mandir and Devi Bhawan Mandir serve city devotees year-round. Panchang, choghadiya, and rahu kaal timings are computed for Hisar's exact coordinates.",
    local_festivals: [
      "Hanuman Jayanti / Kajla Dham festival",
      "Agroha Maha Kumbh (Sharad Purnima)",
      "Navratri",
    ],
  },
  {
    slug: "panipat",
    name: "Panipat",
    name_hi: "पानीपत",
    state: "Haryana",
    latitude: 29.3909,
    longitude: 76.9635,
    timezone: "Asia/Kolkata",
    regional_note:
      "Known as the battlefield of Hindustan, Panipat witnessed three battles that reshaped India's history, in 1526, 1556, and 1761. The ancient Prachin Siddh Shree Devi Mandir on Devi Mandir Road, believed to date to the Mahabharata era, is the city's foremost Hindu shrine, and the Maratha warrior Mangal Raghunath reportedly built the adjacent Shiva temple after the Third Battle. Navratri brings the city's largest religious gatherings to the Devi Mandir, and Kala Amb marks the Maratha command post of 1761. Panchang, choghadiya, and rahu kaal timings are computed for Panipat's exact coordinates.",
    local_festivals: ["Navratri (Prachin Siddh Devi Mandir)", "Diwali", "Mahashivratri"],
  },
  {
    slug: "karnal",
    name: "Karnal",
    name_hi: "करनाल",
    state: "Haryana",
    latitude: 29.6857,
    longitude: 76.9905,
    timezone: "Asia/Kolkata",
    regional_note:
      "Karnal is traditionally held to be the city of Karna, the Mahabharata's great warrior-king and legendary philanthropist, and Karna Lake in the city marks the site where, according to legend, he gave alms to the poor. Karneshwar Mahadev Mandir in Sector 7, built in white marble with a five-faced Shiva Lingam, is the city's most visited temple. Durga Bhawani Mandir draws large crowds during Navratri, and Hariyali Teej, marking Parvati's reunion with Shiva, is widely observed by women across the district. Panchang, choghadiya, and rahu kaal timings are computed for Karnal's exact coordinates.",
    local_festivals: ["Navratri (Durga Bhawani Mandir)", "Hariyali Teej", "Baisakhi"],
  },
  {
    slug: "ambala",
    name: "Ambala",
    name_hi: "अम्बाला",
    state: "Haryana",
    latitude: 30.3752,
    longitude: 76.7821,
    timezone: "Asia/Kolkata",
    regional_note:
      "Ambala takes its very name from Ambika Mata: the ancient Ambika Devi Mandir near the old civil hospital in Ambala City, dedicated to goddesses Amba, Ambika, and Ambalika, predates the British era and is considered the city's founding shrine. Shree Panchmukhi Hanuman Mandir near the railway station, about 250 years old, features artwork reminiscent of the Mughal School of Painting and draws large crowds on Tuesdays, Saturdays, and Hanuman Jayanti. Navratri and Ram Navami are the city's most festive observances. Panchang, choghadiya, and rahu kaal timings are computed for Ambala's exact coordinates.",
    local_festivals: ["Navratri (Ambika Devi Mandir)", "Hanuman Jayanti", "Ram Navami"],
  },
  {
    slug: "sonipat",
    name: "Sonipat",
    name_hi: "सोनीपत",
    state: "Haryana",
    latitude: 28.9288,
    longitude: 77.0218,
    timezone: "Asia/Kolkata",
    regional_note:
      "Strategically placed at the northern edge of the Delhi-Panipat corridor, Sonipat's Hindu religious life centres on the Shiv Mandir in Sector 23, the Kali Mata Temple, and Baba Dham Mandir near the railway station. Mahashivratri is the city's most prominent Hindu festival, drawing devotees from surrounding villages. The fourteenth-century Khwaja Khizr Tomb, an ASI-protected sandstone monument from the Lodi era, stands as the city's best-known heritage site. Navratri observances are held at temples across the city. Panchang, choghadiya, and rahu kaal timings are computed for Sonipat's exact coordinates.",
    local_festivals: ["Mahashivratri (Shiv Mandir)", "Navratri", "Hanuman Jayanti"],
  },
  {
    slug: "yamunanagar",
    name: "Yamunanagar",
    name_hi: "यमुनानगर",
    state: "Haryana",
    latitude: 30.129,
    longitude: 77.2674,
    timezone: "Asia/Kolkata",
    regional_note:
      "Kapal Mochan, 17 km north-east of Yamunanagar on the Bilaspur road, is among the most ancient Vedic pilgrimage sites in Haryana, mentioned in the Puranas and Mahabharata and visited, according to tradition, by both Rama and Shiva. Its annual Kapal Mochan Mela on Kartik Purnima draws nearly five lakh pilgrims for a ritual bath believed to absolve sins. Shree Panchmukhi Hanuman Mandir in Basatian Wala village is the district's prominent five-faced Hanuman shrine. Panchang, choghadiya, and rahu kaal timings are computed for Yamunanagar's exact coordinates.",
    local_festivals: ["Kapal Mochan Mela (Kartik Purnima)", "Hanuman Jayanti", "Navratri"],
  },
  // Uttarakhand
  {
    slug: "nainital",
    name: "Nainital",
    name_hi: "नैनीताल",
    state: "Uttarakhand",
    latitude: 29.3803,
    longitude: 79.4636,
    timezone: "Asia/Kolkata",
    regional_note:
      "Naina Devi Temple, one of the 51 Shakti Peethas marking the spot where the eyes of Goddess Sati are said to have fallen, stands on the northern shore of Naini Lake at around 2,000 m elevation, giving the lake and city their very name. The sanctum enshrines two sacred eyes alongside Kali Devi and Ganesha. Hanuman Garhi temple on the hill above town is another popular shrine. Nanda Devi Mahotsav, the eight-day Nanda Ashtami fair, Navratri, and the Sharadotsav autumn festival are celebrated with great fervour. Panchang, choghadiya, and rahu kaal timings are computed for Nainital's exact coordinates.",
    local_festivals: ["Nanda Devi Mahotsav (Nanda Ashtami)", "Navratri", "Sharadotsav Festival"],
  },
  {
    slug: "roorkee",
    name: "Roorkee",
    name_hi: "रुड़की",
    state: "Uttarakhand",
    latitude: 29.8543,
    longitude: 77.888,
    timezone: "Asia/Kolkata",
    regional_note:
      "Roorkee, in Haridwar district, is celebrated as the city of India's first engineering college, established in 1847 and now IIT Roorkee, and of the historic Ganga Canal whose 19th-century Solani Aqueduct is still visible today. The city has local mandirs including Sidhbali Hanuman Mandir and Nav Durga Mata Mandir, and the great Ganga ghats of Haridwar lie about 31 km away for Kumbh, Ganga Dashami, and Kanwar Yatra observances. Navratri, Diwali, and Mahashivratri are the main festivals celebrated in town. Panchang, choghadiya, and rahu kaal timings are computed for Roorkee's exact coordinates.",
    local_festivals: ["Navratri", "Mahashivratri", "Ganga Dashami"],
  },
];
